import { render, staticRenderFns } from "./User-data-board.vue?vue&type=template&id=36592853&scoped=true"
import script from "./User-data-board.vue?vue&type=script&lang=js"
export * from "./User-data-board.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36592853",
  null
  
)

export default component.exports